import { createSlice } from '@reduxjs/toolkit';
import { getSyncStatus, syncSingleProfile, syncAllProfiles, SyncStatusResponse, SyncAllProfilesResponse } from '../thunks/adminThunks';

interface AdminState {
  syncStatus: SyncStatusResponse | null;
  syncLoading: boolean;
  syncError: string | null;
  lastSyncResult: SyncAllProfilesResponse | null;
}

const initialState: AdminState = {
  syncStatus: null,
  syncLoading: false,
  syncError: null,
  lastSyncResult: null,
};

const adminSlice = createSlice({
  name: 'admin',
  initialState,
  reducers: {
    clearSyncError: (state) => {
      state.syncError = null;
    },
    clearLastSyncResult: (state) => {
      state.lastSyncResult = null;
    },
  },
  extraReducers: (builder) => {
    // Get Sync Status
    builder
      .addCase(getSyncStatus.pending, (state) => {
        state.syncLoading = true;
        state.syncError = null;
      })
      .addCase(getSyncStatus.fulfilled, (state, action) => {
        state.syncLoading = false;
        state.syncStatus = action.payload;
      })
      .addCase(getSyncStatus.rejected, (state, action) => {
        state.syncLoading = false;
        state.syncError = action.payload as string;
      });

    // Sync Single Profile
    builder
      .addCase(syncSingleProfile.pending, (state) => {
        state.syncLoading = true;
        state.syncError = null;
      })
      .addCase(syncSingleProfile.fulfilled, (state) => {
        state.syncLoading = false;
        // Refresh sync status after single sync
      })
      .addCase(syncSingleProfile.rejected, (state, action) => {
        state.syncLoading = false;
        state.syncError = action.payload as string;
      });

    // Sync All Profiles
    builder
      .addCase(syncAllProfiles.pending, (state) => {
        state.syncLoading = true;
        state.syncError = null;
        state.lastSyncResult = null;
      })
      .addCase(syncAllProfiles.fulfilled, (state, action) => {
        state.syncLoading = false;
        state.lastSyncResult = action.payload;
      })
      .addCase(syncAllProfiles.rejected, (state, action) => {
        state.syncLoading = false;
        state.syncError = action.payload as string;
      });
  },
});

export const { clearSyncError, clearLastSyncResult } = adminSlice.actions;
export default adminSlice.reducer;
